import React from 'react';
import { Topbar } from '../components/Topbar';
import { Hero } from '../components/Hero';
import { Reviews } from '../components/Reviews';
import { Problems } from '../components/Problems';
import { Audience } from '../components/Audience';
import { BadgeSystem } from '../components/BadgeSystem';
import { Modules } from '../components/Modules';
import { Exclusives } from '../components/Exclusives';
import { Bonuses } from '../components/Bonuses';
import { ComparisonTable } from '../components/ComparisonTable';
import { OfferSelector } from '../components/OfferSelector';
import { Guarantee } from '../components/Guarantee';
import { FAQ } from '../components/FAQ';
import { FooterCTA } from '../components/FooterCTA';
import { Footer } from '../components/Footer';
import { PurchasePopup } from '../components/PurchasePopup';
export function LandingPage() {
  return <main className="min-h-screen w-full bg-black" data-id="element-294">
      <PurchasePopup data-id="element-295" />
      <Topbar data-id="element-296" />
      <Hero data-id="element-297" />
      <Reviews data-id="element-298" />
      <Problems data-id="element-299" />
      <Audience data-id="element-300" />
      <BadgeSystem data-id="element-301" />
      <Modules data-id="element-302" />
      <Exclusives data-id="element-303" />
      <Bonuses data-id="element-304" />
      <ComparisonTable data-id="element-305" />
      <OfferSelector data-id="element-306" />
      <Guarantee data-id="element-307" />
      <FAQ data-id="element-308" />
      <FooterCTA data-id="element-309" />
      <Footer data-id="element-310" />
    </main>;
}